import { Validators } from '../../../utils/validators';
import { FormModel } from '../../../components/Form';

export const ChangePasswordForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.old_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'oldPassword',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      inputProps: {
        autoComplete: 'current-password',
        name: 'current-password',
      },
    },
    {
      label: strings.new_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'newPassword',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validatePassword }],
      responsive: { xs: 12 },
      required: true,
      inputProps: {
        autoComplete: 'new-password',
        name: 'new-password',
      },
    },
    {
      label: strings.confirm_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'confirmPassword',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validatePassword }],
      responsive: { xs: 12 },
      required: true,
      inputProps: {
        autoComplete: 'new-password',
        name: 'confirm-password',
      },
    },
  ];
};
